import React, { FunctionComponent } from 'react';
import { NavLink } from 'react-router-dom';
import { map, addIndex, replace } from 'ramda';
import withStyles from 'react-jss';
import { Menu } from 'semantic-ui-react';

import { ClassProp } from 'helpers/types';

import { Tabs } from './TabbedMenu.helper';

type Props = {
  classes: ClassProp<typeof styles>;
  url: string;
  tabItems: any;
  merchantName: string;
  hasAccountDetails?: boolean;
};

const styles = {
  tabbedMenu: {
    boxShadow: 'none !important',
    borderRadius: '1.5625rem !important',
    border: 'none !important',
    backgroundColor: '#eef0f3 !important',
    color: '#9BABB7 !important',
    margin: '1.375rem -1rem !important',
    padding: '.3125rem !important',
  },
  tabItem: {
    color: '#a9b8c2 !important',
    fontSize: '.875rem !important',
    '&:before': {
      backgroundColor: 'transparent !important',
    },
    '&:hover': {
      backgroundColor: 'transparent !important',
    },
  },
  active: {
    backgroundColor: '#fff !important',
    borderRadius: '1.5625rem !important',
    boxShadow:
      '0 .0625rem 0 0 rgba(0,0,0,0.03), 0 .125rem .375rem 0 rgba(0,0,0,0.06); !important',
    border: 'solid .0625rem rgba(0, 0, 0, 0.03)',
    color: '#683caf !important',
    '&:hover': {
      backgroundColor: '#fff !important',
    },
  },
};

const mapIndexed = addIndex<Tabs>(map);

const renderMenuItems = (
  classes: ClassProp<typeof styles>,
  url: string,
  merchantName: string,
  hasAccountDetails = false,
) => ({ path, label, key, hideItem = false }: Tabs, idx: number) => {
  if (hideItem) return '';
  if (key === 'accountManagement' && !hasAccountDetails) return '';

  return (
    <Menu.Item
      activeClassName={classes.active}
      className={classes.tabItem}
      to={`${url}${replace(':merchantName', merchantName, path)}`}
      content={label}
      as={NavLink}
      key={`${key}_${idx}`}
    />
  );
};
const MerchantStatusDetails: FunctionComponent<Props> = ({
  classes,
  url,
  tabItems,
  merchantName,
  hasAccountDetails = false,
}) => (
  <Menu className={classes.tabbedMenu}>
    {mapIndexed(
      renderMenuItems(classes, url, merchantName, hasAccountDetails),
      tabItems,
    )}
  </Menu>
);

export default withStyles(styles)(MerchantStatusDetails);
